import React, { useState, useEffect } from "react";
import "./AboutUsVision.css";
import { Image, Stack, Button } from "react-bootstrap";
import { map } from "lodash";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export const AboutUsVision = () => {
  const data = [
    {
      id: 1,
      heading: "Our Global Network",
      desc: [
        "With office across 40+ strategic locations, and DMC to over 15 destinations, Blueberry DMC delivers consistent quality and on-the-ground excellence across diverse markets, from the vibrant landscapes of Africa and the cultural hubs of India and the UAE, to the emerging destinations of Asia. Our integrated network of professionals, suppliers, and partners ensures every journey, event, and operation runs seamlessly wherever your clients choose to travel. ",
      ],
    },
  ];

  const cardData = [
    {
      title: "UAE",
      desc: " Experience the Excitement",
      img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/About%20Us/image%20572.png",
      link: "/destination/uae",
      badgeTitle: "UAE",
      badgeIcon: "/assets/UAE.png",
    },
    {
      title: "Tanzania",
      desc: " Experience the Excitement",
      img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/About%20Us/image%20573.png",
      link: "/destination/tanzania",
      badgeTitle: "Tanzania",
      badgeIcon: "/assets/tanzania.png",
    },
    {
      title: "India",
      desc: "Experience the Excitement ",
      img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/About%20Us/image%20572%20(1).png",
      link: "/destination/india",
      badgeTitle: "India",
      badgeIcon: "/assets/india.png",
    },
    {
      title: "Kenya",
      desc: "Experience the Excitement ",
      img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/About%20Us/image%20573%20(1).png",
      link: "/destination/kenya",
      badgeTitle: "Kenya",
      badgeIcon: "/assets/kenya.png",
    },
    {
      title: "Qatar",
      desc: " Experience the Excitement",
      img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/About%20Us/image%20572%20(2).png",
      link: "/destination/qatar",
      badgeTitle: "Qatar",
      badgeIcon: "/assets/qatar.png",
    },
    {
      title: "South Africa",
      desc: " Experience the Excitement",
      img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/About%20Us/image%20574.png",
      link: "/destination/south-africa",
      badgeTitle: "South Africa",
      badgeIcon: "/assets/south.png",
    },
    // {
    //   title: "Kazakhstan",
    //   desc: " Experience the Excitement",
    //   img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/vision-kazakh.webp",
    //   link: "/destination/kazakhstan",
    //   badgeTitle: "Kazakhstan",
    //   badgeIcon: "/assets/kazakhstan.png",
    // },
    {
      title: "Uganda",
      desc: "Experience the Excitement ",
      img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/About%20Us/image%20574%20(1).png",
      link: "/destination/uganda",
      badgeTitle: "Uganda",
      badgeIcon: "/assets/uganda.png",
    },
    {
      title: "Zambia",
      desc: "Experience the Excitement ",
      img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/About%20Us/image%20572%20(3).png",
      link: "/destination/zambia",
      badgeTitle: "Zambia",
      badgeIcon: "/assets/zambia.png",
    },
    {
      title: "Zimbabwe",
      desc: "Experience the Excitement ",
      img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/About%20Us/image%20574%20(2).png",
      link: "/destination/zimbabwe",
      badgeTitle: "Zimbabwe",
      badgeIcon: "/assets/zimbabwe.png",
    },
    {
      title: "Singapore",
      desc: "Experience the Excitement ",
      img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Singapore.png",
      link: "/destination/singapore",
      badgeTitle: "Singapore",
      badgeIcon: "/assets/location11.png",
    },
    {
      title: "Malaysia",
      desc: "Experience the Excitement ",
      img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/About%20Us/image%20574%20(3).png",
      link: "/destination/malaysia",
      badgeTitle: "Malaysia",
      badgeIcon: "/assets/malaysia.png",
    },
  ];

  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsTablet(window.innerWidth <= 900);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  return (
    <div>
      {map(data, (d, index) => (
        <div
          key={d.id}
          className={`AboutUsVision standard-padding ${index % 2 !== 0 ? "AboutUsVision-odd" : ""
            }`}
        >
          <Stack className="AboutUsVision-container">
            <h2 className="heading AboutUsVision-heading2">Our Vision</h2>

            <div className="AboutUsVision-container1">
              <p className="AboutUsVision-desc dyt">
To redefine destination management by combining global expertise with local authenticity. We aspire to be the most trusted and forward-thinking DMC partner for travel agencies and tour operators worldwide creating transformative travel and event experiences that inspire, connect, and deliver measurable value to our partners, while championing sustainable tourism and the growth of local communities.              </p>

              <h2 className="heading AboutUsVision-heading2">
                {d.heading}
              </h2>

              {map(d.desc, (desc, i) => (
                <p key={i} className="AboutUsVision-desc dyt2">
                  {desc}
                </p>
              ))}
            </div>
          </Stack>

          <Stack className="AboutUsVision-image-container">
            <Image
              className="AboutUsVision-frame"
              src="https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/vision-mission2.webp"
              alt="image"
            />
          </Stack>
        </div>
      ))}

      <div className="standard-padding AboutUsVision2">
        <h1 className="heading mb-4 text-center">
          Built to Power Your Travel Business Across Every Corner of the World
        </h1>

        {isTablet ? (
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={12}
            slidesPerView={2}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            breakpoints={{
              0: { slidesPerView: 1 },
              600: { slidesPerView: 1 },
              900: { slidesPerView: 2 },
            }}
            className="AboutUsVision-card-container"
          >
            {cardData.map((d) => {
              const safeUrl = d.img.replace(/\(/g, "%28").replace(/\)/g, "%29");

              return (
                <SwiperSlide key={d.title}>
                  <div
                    className="AboutUsVision-card"
                    style={{
                      backgroundImage: `linear-gradient(180deg, rgba(10,21,49,0) 0%, rgba(10,21,49,0.4) 100%), url("${safeUrl}")`,
                    }}
                  >
                    <div className="AboutUsVision-batch">
                      <img src={d.badgeIcon} alt="" />
                      <span>{d.badgeTitle}</span>
                    </div>

                    <div className="AboutUsVision-card-body">
                      <h5>{d.title}</h5>
                      <p>{d.desc}</p>

                      <Button
                        onClick={() => (window.location.href = d.link)}
                        className="AboutUsVision-card-button"
                      >
                        Discover More
                      </Button>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        ) : (
          <div className="AboutUsVision-card-container">
            {cardData.map((d) => {
              const safeUrl = d.img.replace(/\(/g, "%28").replace(/\)/g, "%29");

              return (
                <div
                  key={d.title}
                  className="AboutUsVision-card"
                  style={{
                    backgroundImage: `linear-gradient(180deg, rgba(10,21,49,0) 0%, rgba(10,21,49,0.4) 100%), url("${safeUrl}")`,
                  }}
                >
                  <div className="AboutUsVision-batch">
                    <img src={d.badgeIcon} alt="" />
                    <span>{d.badgeTitle}</span>
                  </div>

                  <div className="AboutUsVision-card-body">
                    <h5>{d.title}</h5>
                    <p>{d.desc}</p>

                    <Button
                      onClick={() => (window.location.href = d.link)}
                      className="AboutUsVision-card-button"
                    >
                      Discover More
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};